import script from "./IssueTab.vue?vue&type=script&setup=true&lang=js"
export * from "./IssueTab.vue?vue&type=script&setup=true&lang=js"

import "./IssueTab.vue?vue&type=style&index=0&id=3aa13d67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa13d67"]])

export default __exports__